module.exports = __webpack_public_path__ + "img/change.36bbe430.svg";